/* CTA Section – Sacred Modern Design
 * Dark section with strong call to action
 * "Bereit, dich selbst zu verstehen?"
 */
import { IMAGES } from "@/lib/constants";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

export default function CtaSection() {
  const { t } = useI18n();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="assessment" className="relative py-24 lg:py-32 overflow-hidden" ref={ref}>
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.heroBg}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[oklch(0.12_0.02_280/0.88)]" />
        <div className="absolute inset-0 mandala-overlay pointer-events-none" />
      </div>

      <div className="container relative z-10">
        <div
          className={`text-center max-w-3xl mx-auto transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-[oklch(0.95_0.01_80)] mb-6 leading-tight">
            {t("landing.cta.heading1")}{" "}
            <span className="text-[oklch(0.78_0.11_85)]">{t("landing.cta.heading2")}</span>?
          </h2>

          <p className="text-lg sm:text-xl text-[oklch(0.75_0.02_80)] mb-10 leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.cta.description")}
          </p>

          <a
            href="/funnel"
            className="inline-flex items-center gap-3 btn-olive px-10 py-5 rounded-full text-lg font-semibold tracking-wide group"
          >
            {t("landing.cta.button")}
            <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
          </a>

          <p className="text-sm text-[oklch(0.6_0.02_80)] mt-6" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.cta.trust")}
          </p>
        </div>
      </div>
    </section>
  );
}
